import React from 'react'
import { cn } from '@/lib/utils'
import { COLUMN_WIDTH_CLASS, NAME_WIDTH_CLASS, type ColumnId } from '../lib/columns'
import BillingDifferenceMark from './BillingDifferenceMark'
import { formatMoney, isNegativeMoney } from '../lib/money'
import type { CostValues } from '../types'

interface Props { label: string; values: CostValues; columns: ColumnId[]; currency: string; locale: string }

/** The server's totals for the project (or the filtered level-1 group), stuck to the bottom of the grid. */
const BudgetGridFooter: React.FC<Props> = ({ label, values, columns, currency, locale }) => (
  <div role="row" className="sticky bottom-0 z-30 flex h-9 min-w-max border-t bg-muted text-sm font-semibold">
    <div role="gridcell" className={cn('sticky left-0 z-40 flex shrink-0 items-center border-r bg-muted px-2', NAME_WIDTH_CLASS)}>{label}</div>
    {columns.map((id) => (
      <div
        key={id}
        role="gridcell"
        className={cn('flex shrink-0 items-center justify-end px-2 tabular-nums', COLUMN_WIDTH_CLASS[id], (id === 'variance' || id === 'billingDifference') && isNegativeMoney(values[id]) && 'text-destructive')}
      >
        {id === 'billingDifference' && isNegativeMoney(values[id]) && <BillingDifferenceMark />}
        {id === 'code' ? '' : formatMoney(values[id], { locale, currency, whole: true })}
      </div>
    ))}
  </div>
)
export default BudgetGridFooter
